const versione='10000000';

function Parametri(parametro, identitaSelezionata=[]) {
const versione=392

    //const urlbackendPrimario = 'https://h.massbroken.it:2003/ema/link_back_front.php';
const urlbackendPrimario = 'https://emabackend.massbroken.it/link_back_front.php?v=392';
const urlWebSocket = 'wss://emabackend.massbroken.it/ws';
    
    switch (parametro) {       
        case 'serverURL': 
            if (identitaSelezionata.urlbackend != undefined) {
                if (identitaSelezionata.urlbackend != "primario") return identitaSelezionata.urlbackend;
            }           
            return urlbackendPrimario;
        break;

        case 'serverURLPrimario': 
            return urlbackendPrimario;
        break;

        case 'urlWebSocket': 
            return urlWebSocket;
        break;

case 'release': return "T-"+versione; break;
    }
    return "";
}

export default Parametri;
